module.exports = __webpack_public_path__ + "media/images/icons/icon_close-6d6d18286b33d59fe67090686b6371eb.svg";